import { render, staticRenderFns } from "./AddNoteDialog.vue?vue&type=template&id=01068ce4&scoped=true&"
import script from "./AddNoteDialog.vue?vue&type=script&lang=js&"
export * from "./AddNoteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01068ce4",
  null
  
)

export default component.exports